export function addToBookmark() {
    const addProfileToBookmark = document.querySelectorAll('.add-profile-to-bookmark');

    addProfileToBookmark.forEach((bookmark: HTMLElement) => {
        bookmark.addEventListener('click', (e) => {
            e.preventDefault();
            const identifier = bookmark.dataset.bookmarkIdentifier;

            if (!identifier) {
                return;
            }

            bookmark.classList.add('loading');

            const url = new URL('/bookmarks/add', window.location.origin);

            const request = async () => {
                return await fetch(url.toString(), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify({
                        identifier: identifier,
                    }),
                })
                    .then(response => response.json())
                    .then(data => {
                        const bookmarkAll = document.querySelectorAll(`.add-profile-to-bookmark[data-bookmark-identifier="${identifier}"]`);

                        bookmarkAll.forEach((bookmarkEl: HTMLElement) => {
                            bookmarkEl.classList.remove('loading');

                            if (data.state === 'added') {
                                bookmarkEl.classList.add('active');
                            }
                            if (data.state === 'removed') {
                                bookmarkEl.classList.remove('active');
                            }
                        });
                    });
            }

            request();
        }, {passive: false});
    });
}

export function getList(updateList: boolean = false) {
    const url = new URL('/bookmarks/list', window.location.origin);

    const request = async () => {
        return await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .then(response => response.json())
            .then(data => {
                return data.bookmarks;
            });
    }

    request().then((bookmarks) => {
        if (updateList) {
            for (let i = 0; i < bookmarks.length; i++) {
                const bookmarkAll = document.querySelectorAll(`.add-profile-to-bookmark[data-bookmark-identifier="${bookmarks[i]}"]`);

                bookmarkAll.forEach((bookmark: HTMLElement) => bookmark.classList.add('active'));
            }
        }
    });
}

if (document.querySelector('body.solutions-searcher')) {
    addToBookmark();
    getList(true);
}
